
import angular from 'angular';

export var advancedApp = angular.module('advancedapp', ['afkl.lazyImage']).config(['$httpProvider', function ($httpProvider) {
    
}]);

